module.exports = __webpack_public_path__ + "img/2.041be2d2.png";